import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CompanyService } from 'src/app/company.service';
import { GetHostsModelResponse } from 'src/app/_models/Host/HostModel';
import { Operations } from 'src/app/_models/Operations/Operations';
import { VenueModelResponse } from 'src/app/_models/Venue/VenueModel';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-multi-select-host',
  templateUrl: './multi-select-host.component.html',
  styleUrls: ['./multi-select-host.component.scss']
})
export class MultiSelectHostComponent implements OnInit {

  @Input() list:any[] = [];
  public hostList: GetHostsModelResponse[] = [];
  @Input() operation:number = Operations.Add;
  @Input() checkedItems: any[];

  companyId: string = "";

  @Output() shareCheckedList = new EventEmitter();

  checkedList: any[];

  constructor(
    private apiService: ApiService,
    private companyService: CompanyService,
    
    ) {
    this.checkedList = [];
  }

  ngOnInit(): void {
    this.fetchHosts();
    this.shareCheckedlist();
  }

  fetchHosts() {
    this.getCompanyId();
    this.apiService.getHostsByCompany(this.companyId).subscribe((result)=>{
      this.hostList = result;
      if(this.operation == Operations.Edit){
        this.checkIfPopulated();
      }
    });
  }

  getCompanyId(){
    this.companyId = this.companyService.getCompanyId();
  }

  checkIfPopulated() {
      this.hostList.map((host) => {
        if(this.checkedItems){
          this.checkedItems.map((id)=> {
            if(host.id == id){
              this.checkedList.push(host);
            }
          });
        }
      });
  }

  shareCheckedlist() {
    this.shareCheckedList.emit(this.checkedList);
  }
}
